export default "__VITE_ASSET__CAG81QsJ__"